import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { AddCircle, Info, Visibility } from "@mui/icons-material";
import { Box, Button, Card, Stack, Typography } from "@mui/material";

import CreateBedRailAssessmentModal from "./CreateBedRailAssessmentModal";
import { getBedRailAssessments } from "../../../../../api/services/Assessment/BedRailAssessment";
import TableComponent from "../../../../TableComponent/TableComponent";
import { formatDateField } from "../../../../../base/FormatTime";
import { QK } from "../../../../../base/qk";
import AssessmentRiskTooltip from "../ClientAssessments/AssessmentRiskTooltip";

const BedRailAssessment = () => {
  const { id: clientID } = useParams();
  const [selectedAssessment, setSelectedAssessment] = useState(null);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showCreateAssessmentModal, setShowCreateAssessmentModal] =
    useState(false);

  const { data: bedRailAssessments, isLoading } = useQuery(
    [QK.bedRailAssessments, clientID],
    () => getBedRailAssessments(clientID),
    { enabled: !!clientID, keepPreviousData: true }
  );

  const handleShowDetailsModal = (assessment) => {
    setSelectedAssessment(assessment);
    setShowDetailsModal(true);
  };

  const handleCreateNewAssessment = () => {
    setShowCreateAssessmentModal(true);
  };

  const columns = [
    {
      field: "created_at",
      headerName: "Date",
      render: (value) => formatDateField(value),
    },
    { field: "client_name", headerName: "Service User" },
    { field: "created_by_name", headerName: "Created By" },
  ];

  const actions = [
    {
      icon: <Visibility />,
      color: "primary",
      handler: (assessment) => handleShowDetailsModal(assessment),
    },
  ];

  return (
    <div className="w-75 mx-auto">
      <Card sx={{ mb: 3 }}>
        <Box sx={{ bgcolor: "white", color: "black", p: 2 }}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
          >
            <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
              <Typography variant="h5">Bed Rail Assessment</Typography>
              <AssessmentRiskTooltip
                assessmentType="Bed Rail"
                riskLevels={[]} // you can configure risk levels like capabilityRiskLevels
                icon={Info}
                iconColor="info"
                size="small"
                placement="right"
              />
            </Box>
            <Button
              variant="contained"
              startIcon={<AddCircle />}
              color="primary"
              onClick={handleCreateNewAssessment}
            >
              New Assessment
            </Button>
          </Stack>
        </Box>
      </Card>
      <div>
        <TableComponent
          data={bedRailAssessments || []}
          columns={columns}
          actions={actions}
          isLoading={isLoading}
          size="small"
        />
      </div>
      <CreateBedRailAssessmentModal
        clientId={clientID}
        open={showCreateAssessmentModal}
        handleClose={() => setShowCreateAssessmentModal(false)}
      />
      {/* <BedRailAssessmentDetailsModal
        open={showDetailsModal}
        handleClose={() => setShowDetailsModal(false)}
        assessment={selectedAssessment}
      /> */}
    </div>
  );
};

export default BedRailAssessment;
